export default [
    {
        path: '/manager',
        name: 'ManagerDashboard',
        component: () => import('@/views/manager/home.vue'),
        meta: { access: 'auth', title: 'routes.manager.dashboard' },
    },
    {
        path: '/manager/support',
        name: 'ManagerSupport',
        component: () => import('@/views/manager/support/index.vue'),
        meta: { access: 'auth', title: 'routes.manager.dashboard' },
    },
    {
        path: '/manager/bal',
        name: 'ManagerB',
        component: () => import('@/views/manager/support/bal.vue'),
        meta: { access: 'auth', title: 'routes.manager.dashboard' },
    },
    {
        path: '/manager/tasks',
        name: 'ManagerTask',
        component: () => import('@/views/manager/task.vue'),
        meta: { access: 'auth', title: 'routes.manager.tasks' },
    },
    {
        path: '/manager/task/:id',
        name: 'ManagerViewTask',
        component: () => import('@/views/manager/TemplateRequestOverview.vue'),
        meta: { access: 'auth', title: 'routes.manager.view_task' },
    },
    {
        path: '/manager/task/:id/sheets',
        name: 'TemplateRequestSheets',
        component: () => import('@/views/manager/TemplateRequestSheets.vue'),
        meta: { access: 'auth', title: 'routes.manager.sheets', permissions: ['samo.templates.manage'] }
    },
    {
        path: '/support',
        name: 'support',
        component: () => import('@/views/support/index.vue'),
        meta: { access: 'auth', title: 'routes.core.support' }
    },
];